import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMastercardComponent } from './simple-icons-mastercard.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMastercardComponent ],
    exports:      [ SimpleIconsMastercardComponent ],
    bootstrap:    []
})
export class SimpleIconsMastercardModule {}
